import React, { useEffect, useState } from "react";
import {
  Button,
  Col,
  Container,
  Dropdown,
  Nav,
  Navbar,
  Row,
} from "react-bootstrap";
import Offcanvas from "react-bootstrap/Offcanvas";
import { FaCaretDown, FaChevronDown, FaChevronRight } from "react-icons/fa";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import * as styles from "./style.module.scss";
import { Link, useStaticQuery, graphql } from "gatsby";
import useScrollBar from "../../hooks/useScrollBar";
import Services from "../Services/index";
import ServicesMb from "../ServicesMb/index";

const Header = () => {
  const data = useStaticQuery(
    graphql`
      query header_footer {
        strapiPage(slug: { eq: "layout-header" }) {
          sections {
            title
            subTitle
            cards {
              title
              subTitle
              description {
                data {
                  description
                }
              }
              image1 {
                alternativeText
                localFile {
                  publicURL
                }
              }
              image2 {
                alternativeText
                localFile {
                  publicURL
                }
              }
              buttons {
                title
                url
              }
              jsonData {
                # footerData {
                #   addressData {
                #     title
                #     addresses {
                #       addresss
                #       link
                #       tel
                #       title
                #     }
                #   }
                #   pageData {
                #     title
                #     pages {
                #       label
                #       link
                #       disabled
                #     }
                #   }
                # }
                headerData {
                  pageData {
                    pages {
                      disabled
                      label
                      link
                      dropdown
                      subMenuType
                      isStaging
                      subMenu {
                        disabled
                        label
                        link
                      }
                    }
                  }
                }
              }
            }
            secImages {
              alternativeText
              localFile {
                publicURL
              }
              url
            }
            buttons {
              title
              url
            }
            description {
              data {
                description
              }
            }
          }
          seo {
            metaTitle
            metaDescription
          }
        }
      }
    `
  );

  // const [headerStyle, setHeaderStyle] = useState({
  //   top: "35px",
  // });

  // useEffect(() => {
  //   function updateHeaderPosition() {
  //     const header = document.querySelector("#myHeader");
  //     const isMobile = window.innerWidth <= 576;

  //     // if (header) {
  //     //   const specificPages = [
  //     //     // "/blog/chatbots-vs-conversational-ai-a-thorough-comparison/",
  //     //     // "/blog/what-is-cryptojacking-a-beginners-guide/",
  //     //     // "/blog/top-7-web3-jobs-you-don-t-want-to-miss-in-2024/",
  //     //   ];
  //     const specificPages = strapiData.sections.map((item) => {
  //       return data?.strapiBlogPost?.relatedBlogs?.blogs?.slug;
  //     });

  //     if (specificPages.includes(window.location.pathname)) {
  //       if (isMobile) {
  //         setHeaderStyle({ top: "100px" });
  //       } else {
  //         setHeaderStyle({ top: "60px" });
  //       }
  //     } else {
  //       setHeaderStyle({ top: "35px" });
  //     }
  //   }

  //   // Call the function when the page loads, and when the window is resized
  //   window.addEventListener("load", updateHeaderPosition);
  //   window.addEventListener("resize", updateHeaderPosition);
  //   // Initial call when component is mounted
  //   updateHeaderPosition();
  // }, []);

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.pageYOffset;
      const isScrollingUp = prevScrollPos > currentScrollPos;

      setPrevScrollPos(currentScrollPos);

      if (!isScrollingUp) {
        setVisible(false);
      } else {
        setVisible(true);
      }
    };
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [prevScrollPos]);

  const headerClasses = `${styles.header} ${
    visible ? styles.visibleHeader : styles.hiddenHeader
  }`;

  const [collapseMenu, setCollapseMenu] = useState(false);
  const [renderMenu, setRenderMenu] = useState(false);
  const scrollValue = useScrollBar();
  const { width } = useWindowDimensions();
  const scrollWidth = width > 991;

  const [show, setShow] = useState(false);

  const [showDropdown, setShowDropdown] = useState(false);
  const [showIcon, setShowIcon] = useState(false);

  const handleClose = () => {
    setShow(false);
    setRenderMenu(false);
  };
  const handleCloseStatic = () => {
    setShow(false);
    setShowDropdown(false);
  };

  useEffect(() => {
    setCollapseMenu(false);
  }, [scrollWidth]);

  useEffect(() => {
    setRenderMenu(false);
  }, []);

  useEffect(() => {
    setShowDropdown(false);
  }, []);

  const clickHandler = (link) => {
    window.location.href = link;
  };

  const hoverHandler = (name) => {
    setRenderMenu(true);
  };
  const strapiData = data?.strapiPage?.sections[0];
  const SiteLogo =
    data?.strapiPage?.sections[1]?.secImages[0]?.localFile?.publicURL;
  const items = strapiData?.cards[0]?.jsonData?.headerData?.pageData?.pages;
  const contactLink = strapiData?.cards[0]?.buttons[0];

  const NavBarData = [
    {
      link: "/",
      label: "Home",
      disabled: false,
      subMenuType: "none",
    },
    {
      mobileLabel: "View All",
      link: "/services/",
      label: "Services",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/smart-contract-development/",
          label: "Smart Contract Development",
          disabled: false,
        },
        {
          link: "/enterprise-blockchain-development/",
          label: "Enterprise Blockchain Development",
          disabled: false,
        },
        {
          link: "/web3-development-services/",
          label: "Web3 Development Services",
          disabled: false,
        },
        {
          link: "/blockchain-consulting-services/",
          label: "Blockchain Consultancy",
          disabled: false,
        },
        {
          link: "/cryptocurrency-wallet-development/",
          label: "Cryptocurrency Wallet Development",
          disabled: false,
        },
        {
          link: "/token-development-services/",
          label: "Token Development Services",
          disabled: false,
        },
        {
          link: "/dao-development-services/",
          label: "DAO Development Services",
          disabled: false,
        },
        {
          link: "/crypto-exchange-development/",
          label: "Crypto Exchange Software Development",
          disabled: false,
        },
        {
          link: "/dapp-development-services/",
          label: "DApp Development Services",
          disabled: false,
        },
        {
          link: "/defi-platform-development/",
          label: "DeFi Development",
          disabled: false,
        },
        {
          link: "/nft-development-services/",
          label: "NFT Development Services",
          disabled: false,
        },
        {
          link: "/crypto-marketing-services/",
          label: "Crypto Marketing Services",
          disabled: false,
        },
        {
          link: "/smart-contract-audit-services/",
          label: "Smart Contract Audit Services",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      link: "/industries/",
      label: "Industries",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/fintech-blockchain-development/",
          label: " FinTech",
          disabled: false,
        },
        {
          link: "/metaverse-development-company/",
          label: "Metaverse",
          disabled: false,
        },
        {
          link: "/blockchain-supply-chain-development/",
          label: "Supply Chain",
          disabled: false,
        },
        {
          link: "/healthcare-blockchain-development/",
          label: "Healthcare",
          disabled: false,
        },
        {
          link: "/real-estate-blockchain-development/",
          label: "Real Estate",
          disabled: false,
        },
        {
          link: "/education-blockchain-development/",
          label: "Education",
          disabled: false,
        },
        {
          link: "/ecommerce-blockchain-development/",
          label: "Ecommerce",
          disabled: false,
        },
        {
          link: "/retail-blockchain-development/",
          label: "Retail",
          disabled: false,
        },
        {
          link: "/travel-blockchain-development/",
          label: "Travel and Transportation",
          disabled: false,
        },
      ],
    },
    {
      mobileLabel: "View All",
      link: "",
      label: "AI",
      disabled: true,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/ai-development-company/",
          label: "AI Development Company",
          disabled: false,
        },
        {
          link: "/machine-learning-development-services/",
          label: "ML Development Services",
          disabled: false,
        },
        {
          link: "/ai-chatbot-development-company/",
          label: "AI Chatbot Development Company",
          disabled: false,
        },
      ],
    },
    {
      link: "/about-us/",
      label: "Portfolio",
      disabled: false,
      subMenuType: "none",
    },
    {
      mobileLabel: "View All",
      link: "/technologies/",
      label: "Insights",
      disabled: false,
      dropdown: true,
      subMenuType: "list",
      subMenu: [
        {
          link: "/about-us/",
          label: "About Us",
          disabled: false,
        },
        {
          link: "/blog/",
          label: "Blog",
          disabled: false,
        },
      ],
    },

    {
      link: "/pricing/",
      label: "Pricing",
      disabled: false,
      subMenuType: "none",
    },
  ];

  return (
    <header className={`${styles.headerwrap}`}>
      {/* static Navbar */}
      <Container
        id="myHeader"
        // style={{ top: headerStyle.top }}
        className={`${styles.header} ${headerClasses} ${
          scrollValue > 0.5 ? styles.backgroundBlur : ""
        }`}
      >
        <div className={styles.overlay}></div>
        <Navbar className={`${styles.navbar}`} expand="xl">
          <Navbar.Brand as={Link} to="/">
            <img
              loading="lazy"
              className={`${styles.SiteLogo}`}
              src={SiteLogo}
              alt="InvoZone"
              placeholder="blurred"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            onClick={() => {
              setCollapseMenu(true);
              setShow(true);
            }}
            aria-controls="offcanvasNavbar"
            className={`${styles.navToggle}`}
          />
          {!collapseMenu && (
            <Navbar.Collapse id="main-navbar-nav" className={styles.navLinks}>
              <Nav
                className={`mx-auto align-items-center justify-content-center`}
              >
                {NavBarData?.map((item, id) => {
                  const {
                    label,
                    link,
                    disabled,
                    isStaging,
                    subMenuType,
                    subMenu,
                  } = item;

                  if (subMenuType === "none") {
                    return (
                      <Link
                        as={Link}
                        to={link}
                        disabled={
                          process.env.GATSBY_STRAPI_NODE_ENV ===
                            "development" && isStaging === true
                            ? false
                            : disabled
                        }
                        key={`${label}-nv`}
                        activeClassName="active"
                        id={`header_${link}_btn_gt_1`}
                        className={`header-border-animation px-0 ${styles.navLinkText}`}
                      >
                        {label}
                      </Link>
                    );
                  } else if (subMenuType === "grid") {
                    return (
                      <Dropdown
                        key={`${label}-ndp`}
                        alignright="true"
                        className="megaMenuColumnbox"
                        onMouseEnter={() => setShowDropdown(id)}
                        onMouseLeave={() => setShowDropdown(-1)}
                        show={showDropdown === id ? true : false}
                      >
                        <Dropdown.Toggle
                          as={Link}
                          to={`${link}`}
                          className="text-white"
                          id="dropdown-autoclose-outside"
                          role="button"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          aria-label={label}
                        >
                          {label}
                          <FaCaretDown className={styles.alignHeaderDropIcon} />
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Row
                            className={[
                              styles.dropdownMulticolMenu,
                              subMenu?.length > 8
                                ? styles.column3
                                : styles.column2,
                            ]}
                            style={{ maxHeight: 400, overflowY: "auto" }}
                          >
                            {subMenu?.map((subItem) => (
                              <Col
                                lg={4}
                                className={styles.megaMenuColumn}
                                key={`${subItem.label}-ndpi`}
                              >
                                <Dropdown.Item
                                  as={Link}
                                  to={`${subItem.link}`}
                                  className={`container justify-content-start ${styles.megaMenuLink}`}
                                  aria-label={subItem.label}
                                  role="menuitem"
                                >
                                  <div className="d-flex ml-2">
                                    {subItem.label}
                                  </div>
                                </Dropdown.Item>
                                <Dropdown.Divider />
                              </Col>
                            ))}
                            <Col
                              lg={12}
                              className={`justify-content-end d-flex pt-2 pt-md-1`}
                            >
                              <Link to={`/${link}/`}>
                                <Button
                                  className="btn_black_border font-weight-normal"
                                  style={{ fontSize: 13 }}
                                  aria-label="View All"
                                >
                                  View All
                                </Button>
                              </Link>
                            </Col>
                          </Row>
                        </Dropdown.Menu>
                      </Dropdown>
                    );
                  } else if (subMenuType === "list") {
                    return (
                      <Dropdown
                        key={`${label}-ndp`}
                        alignright="true"
                        className={`${styles.serviceBtn} megaMenuColumnbox`}
                        onMouseEnter={() => setShowDropdown(id)}
                        onMouseLeave={() => setShowDropdown(-1)}
                        show={showDropdown === id ? true : false}
                      >
                        <Dropdown.Toggle
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          role="button"
                          className={`px-0 ${styles.dropdowntext} nav-link`}
                          onClick={() => clickHandler(link)}
                          aria-label={label}
                        >
                          {label}
                          <FaCaretDown className={styles.alignHeaderDropIcon} />
                        </Dropdown.Toggle>
                        {label === "Services" && showDropdown === id ? (
                          <div className={`${styles.servicesComp}`}>
                            <Services />
                          </div>
                        ) : (
                          <Dropdown.Menu
                            renderOnMount={showDropdown === id ? true : false}
                            className={`ml-3`}
                          >
                            <Row className={`px-0 ${styles.dropMenu}`}>
                              <Col xs={12} className="px-0 pb-0">
                                {subMenu?.map((subItem, index) => (
                                  <div
                                    className={` ${styles.dropMenuWrap} px-3`}
                                    key={`${subItem.label}-ndpi`}
                                  >
                                    <Dropdown.Item
                                      as={Link}
                                      to={subItem.link}
                                      className={`${styles.DropDownItem}`}
                                      disabled={subItem.disabled}
                                      role="menuitem" // Added role attribute
                                      aria-label={subItem.label}
                                    >
                                      {/* Row React Bootstrap */}
                                      <Row
                                        className={`${styles.menuItem}`}
                                        onMouseEnter={() => setShowIcon(index)}
                                        onMouseLeave={() => setShowIcon(-1)}
                                      >
                                        <Col
                                          xs={1}
                                          md={1}
                                          className={`align-items-center justify-content-center px-0 ${
                                            styles.col
                                          } ${
                                            showIcon === index
                                              ? "d-flex"
                                              : "d-none"
                                          }`}
                                        >
                                          <FaChevronRight
                                            className={styles.dropdownIcon}
                                          />
                                        </Col>
                                        <Col
                                          xs={11}
                                          md={11}
                                          className={`d-flex align-items-center px-0 ${styles.col}`}
                                        >
                                          <div>{subItem.label}</div>
                                        </Col>
                                      </Row>
                                    </Dropdown.Item>
                                    <hr />
                                  </div>
                                ))}
                              </Col>
                            </Row>
                          </Dropdown.Menu>
                        )}
                      </Dropdown>
                    );
                  }
                })}
              </Nav>
              <Link
                as={Link}
                to={contactLink?.url}
                className={`d-flex align-items-center justify-content-center homeButton ms-md-3 ${styles.contactLink}`}
                id="header_contact_us_btn_gt_2"
                aria-label={contactLink?.title}
              >
                {contactLink?.title}
              </Link>
            </Navbar.Collapse>
          )}
          {/* Mobile View */}
          <Navbar.Offcanvas
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
            show={show}
            onHide={handleCloseStatic}
          >
            <Offcanvas.Header closeButton>
              <Link to="/">
                <img
                  loading="lazy"
                  src={SiteLogo}
                  alt="InvoZone"
                  placeholder="blurred"
                />
              </Link>
            </Offcanvas.Header>
            <Offcanvas.Body className={styles.offcanvasBody}>
              <Nav
                className={`justify-content-end flex-grow-1 mt-4 pt-3 ${styles.offcanvasNav}`}
              >
                {NavBarData?.map((item, id) => {
                  const {
                    label,
                    link,
                    disabled,
                    subMenu,
                    subMenuType,
                    mobileLabel,
                  } = item;
                  if (subMenuType === "none") {
                    return (
                      <Link
                        as={Link}
                        to={link}
                        onClick={handleCloseStatic}
                        disabled={disabled}
                        key={`${label}-nv`}
                        activeClassName="active"
                        id={`header_${link}_btn_gt_3`}
                        className={`mx-3 my-0 header-border-animation ${styles.navLinkText}`}
                        aria-label={label}
                      >
                        {label}
                      </Link>
                    );
                  } else if (subMenuType !== "none") {
                    return (
                      <Dropdown
                        key={`${label}-ndp`}
                        alignright="true"
                        onMouseEnter={() => setShowDropdown(id)}
                        onMouseLeave={() => setShowDropdown(-1)}
                        show={showDropdown === id ? true : false}
                      >
                        <Dropdown.Toggle
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          role="button"
                          as={Link}
                          className={`mx-3 my-0 ${styles.dropdowntext} nav-link`}
                        >
                          {label}

                          {!(showDropdown === id ? true : false) && (
                            <FaChevronRight className={styles.dropdownIcon} />
                          )}
                          {(showDropdown === id ? true : false) && (
                            <FaChevronDown className={styles.dropdownIcon} />
                          )}
                        </Dropdown.Toggle>
                        {label === "Services" && showDropdown === id ? (
                          <div className={`${styles.servicesComp}`}>
                            <ServicesMb />
                          </div>
                        ) : (
                          <Dropdown.Menu
                            renderOnMount={showDropdown === id ? true : false}
                            className={`mx-3 bg-transparent`}
                          >
                            <Row className={`mx-0 ${styles.dropMenu}`}>
                              <Col xs={12}>
                                {subMenu?.map((subItem) => (
                                  <div key={`${subItem.label}-ndpi`}>
                                    <Dropdown.Item
                                      as={Link}
                                      to={subItem.link}
                                      className={"dropdownItem"}
                                      disabled={subItem.disabled}
                                    >
                                      <Row className={styles.menuItem}>
                                        <Col
                                          xs={2}
                                          md={2}
                                          className="d-flex align-items-center justify-content-center px-0"
                                        >
                                          <div
                                            className={styles.menuCircle}
                                          ></div>
                                        </Col>
                                        <Col
                                          xs={10}
                                          md={10}
                                          className={`d-flex align-items-center px-0 ${styles.dropdownTxt}`}
                                        >
                                          <div>{subItem.label}</div>
                                        </Col>
                                      </Row>
                                    </Dropdown.Item>
                                  </div>
                                ))}
                                {/* Mobile View DropDown Button  */}
                                <div className={`${styles.mobileNavWrap}`}>
                                  <Link
                                    as={Link}
                                    to={link}
                                    onClick={handleCloseStatic}
                                    disabled={disabled}
                                    key={`${mobileLabel}-nv`}
                                    activeClassName="active"
                                    id={`header_${link}_btn_gt_3`}
                                    className={`btnRadius ${styles.navLinkText} ${styles.mobileNav}`}
                                  >
                                    <span>{mobileLabel}</span>
                                  </Link>
                                </div>
                              </Col>
                            </Row>
                          </Dropdown.Menu>
                        )}
                      </Dropdown>
                    );
                  }
                })}
                <Link
                  as={Link}
                  to={contactLink?.url}
                  onClick={handleCloseStatic}
                  activeClassName="active"
                  id={`header_${contactLink?.url}_btn_gt_4`}
                  className={`mx-3 my-2 fw-bold ${styles.navLinkText}`}
                  aria-label={contactLink?.title}
                >
                  {contactLink?.title}
                </Link>
              </Nav>
            </Offcanvas.Body>
          </Navbar.Offcanvas>
          {/* </div> */}
        </Navbar>
      </Container>
    </header>
  );
};

export default Header;
